import React from 'react';
import { Button } from '@/ui/components/Button';
import { Icon } from '@/ui/icons/Icon';
import styles from './ContactSupportTeamButton.module.scss';
import { useFreshchat } from '../../hooks/useFreshchat';

export const ContactSupportTeamButton: React.FC = () => {
  const { showWidget } = useFreshchat();

  return (
    <Button
      trackingId="contact_support_team"
      onClick={showWidget}
      variant="tonal"
      className={styles.callButton}
      leftIcon={<Icon name="phone" />}
      text="Contactează echipa"
    />
  );
};
